import React, { useRef, useState } from 'react';
import { Button, Input } from 'components/core';
import { FormControl, FormLabel } from 'components/core';
import { Inline } from 'components/layout';

type Props = {
  onUpload: (url: string) => void;
};

export default function DocumentUrlUploader({ onUpload }: Props) {
  const documentUrlRef = useRef<HTMLInputElement>(null);
  const [error, setError] = useState<string>('');

  return (
    <div>
      <FormLabel htmlFor="linkToFullText" size="sm">
        Link to full text
      </FormLabel>
      <Inline spacing={2} alignX="left" alignY="top">
        <FormControl
          error={error}
          helperText="Only add links if you are unable to upload PDFs. Only one link can be added."
        >
          <Input
            id="linkToFullText"
            ref={documentUrlRef}
            name="document_url"
            size="sm"
            isError={!!error}
          />
        </FormControl>
        <Button
          variant="outline"
          size="sm"
          onClick={() => {
            let documentUrl = documentUrlRef.current?.value?.trim();
            if (!documentUrl) {
              return setError('Link cannot be empty');
            }
            if (!documentUrl.startsWith('http')) {
              documentUrl = 'https://' + documentUrl;
            }

            setError('');
            onUpload(documentUrl);
            if (documentUrlRef.current) {
              documentUrlRef.current.value = '';
            }
          }}
        >
          Add link
        </Button>
      </Inline>
    </div>
  );
}
